import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack, TextField } from '@mui/material';
import classNames from 'classnames';
import { useState } from 'react';
import { useProductQuantityInputStyles } from '../../../components/Product/useProductQuantityInputStyles';
import LangEnum from '../../../lang/LangEnum';
import teceoInputConfig from '../../../utils/TeceoInputConfig';
import { CopyOrderModalTestIds } from '../../../utils/testIds/CopyOrderModal.testIds';
import { useTranslation } from '../../translation/TranslationContext';
import { usePackStyles } from '../products/product/grid/components/packsMenu/styles/usePackStyles';

interface IOrderGridSettings {
  onChangeInsertGridMultiplier(value: number, maintainOriginalParts?: boolean): void;
}

const OrderGridSettings = ({ onChangeInsertGridMultiplier }: IOrderGridSettings) => {
  const { classes: packStyles } = usePackStyles();
  const { classes: productInputStyles } = useProductQuantityInputStyles();
  const [maintainOriginalParts, setMaintainOriginalParts] = useState(true);
  const { translate } = useTranslation();

  const handleCheckMaintainOriginalParts = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setMaintainOriginalParts(checked);
    onChangeInsertGridMultiplier(1, checked);
  };

  return (
    <Stack sx={{ gap: 1 }}>
      <Checkbox
        label={translate(LangEnum.SUGGESTED_ORDER_COPY_MAINTAIN_ORIGINAL_PARTS)}
        checked={maintainOriginalParts}
        onChange={handleCheckMaintainOriginalParts}
        slotProps={{ input: { 'test-id': CopyOrderModalTestIds.MAINTAIN_PARTS_CHECKBOX } }}
      />
      {!maintainOriginalParts && (
        <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
          <Typography color="text.secondary" sx={{ wordBreak: 'normal' }}>
            {translate(LangEnum.SUGGESTED_ORDER_COPY_DEFINE_MULTIPLIER_PARTS)}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginLeft: 'auto',
              width: 76,
              gap: 0.5,
            }}
          >
            <Typography color="text.secondary">x</Typography>
            <TextField
              {...teceoInputConfig}
              id="outlined-number"
              type="number"
              defaultValue={1}
              onChange={(ev) => onChangeInsertGridMultiplier(Number(ev.target.value), false)}
              className={classNames(packStyles.multiplierTextField, productInputStyles.textField)}
              slotProps={{
                htmlInput: { min: 0, 'test-id': CopyOrderModalTestIds.MULTIPLIER_INPUT },
              }}
            />
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default OrderGridSettings;
